module.exports = __webpack_public_path__ + "img/ak2yth-designbg.1646b425.jpg";